// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"3598c65c","101":"fc887a5b"}[chunkId] + ".chunk.js";
};